import { Component, Input } from '@angular/core';
import { ModalService } from 'services';
import { Backdrop, ModalOptions, Position, Size } from '../types';

@Component({
    selector: 'fc-access-note',
    templateUrl: './access-note.component.html',
    styleUrls: ['./access-note.component.less'],
    standalone: false
})
export class AccessNoteComponent {
    @Input() modalId: string;
    @Input() options: ModalOptions = {
        size: Size.Md,
        backdrop: Backdrop.Static,
        position: Position.Center,
        showCancelButton: false
    };
    // add type
    @Input() openAccessRequest;

    constructor(private modalService: ModalService) {}

    public close() {
        this.modalService.close(this.modalId);
    }
}
